import theme from "@/styles/theme";
import { Box, TextField } from "@mui/material";
import styled from "styled-components";

export const ContainerSearch = styled(Box)`
  && {
    flex: 1;
    @media (max-width: 800px) {
      width: 100%;
      flex: none;
    }
  }
`;

export const TextFieldStyled = styled(TextField)`
  & .css-fdmnco-MuiInputBase-root-MuiOutlinedInput-root {
    background: ${(props) => (props.disabled ? "#F1F1F4" : "transparent")};
    border-radius: 4px !important;
    padding: 0px 8px;
    width: 100%;
  }

  .MuiInputBase-root {
    height: 46px;
    border-style: solid;
    border-width: 1px;
    border-color: ${theme.colors.palete.gold};
    color: white;
    width: 30vw;
    margin-right: 3px;
    @media ${theme.devices.tablet} {
      width: 100%
    }

  }

  & input::placeholder {
    font-size: 14px;
    line-height: 20px;
  }

  /* Sobrescreve a borda aplicada no estado de foco */
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: white; /* ou transparent, se preferir remover totalmente a borda */
  }
`;
